module.exports = __webpack_public_path__ + "static/media/Graphicdesign.d545b580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/MunafaMart/Graphicdesign.jpg
// module id = 336
// module chunks = 0